module.exports = __webpack_public_path__ + "static/media/private-group.0f26cd05.svg";